import React, {useEffect, useState} from 'react';
import {AtRadio} from "taro-ui";
import {LabelWidget} from "../../index";

const TRadioWidget = (props:any) => {
  const {
    label,
    value:wValue,
    defaultOptionValue,
    currentData,
    updateWidgetProperty,
    bgColor,
    color,
    fontSize,
    fontStyle,
    inputFontSize,
    inputColor,
    inputFontStyle,
    onLoad,
    dictOnLoad,
    onLazyLoad,
    options,
    readonly,
    labelPosition,
    labelAlignment,
    isRequired,
    borderBottomColor,
    borderBottomWidth,
    labelWidth,
    placeholderAlignment,
    iconColor,
    iconAlignment
  } = props;
  const [value, setValue] = useState('');
  const onChange = (v:any)=>{
    if(!readonly){
      setValue(v);
      updateWidgetProperty&&updateWidgetProperty(v);
    }
  };
  useEffect(()=>{
    setValue(wValue??defaultOptionValue);
  }, [wValue, defaultOptionValue])
  return (
    <LabelWidget
      label={label}
      fontSize={fontSize}
      color={color}
      fontStyle={fontStyle}
      bgColor={bgColor}
      inputFontSize={inputFontSize}
      inputColor={inputColor}
      inputFontStyle={inputFontStyle}
      labelAlignment={labelAlignment}
      labelPosition={labelPosition}
      required={isRequired}
      borderBottomColor={borderBottomColor}
      borderBottomWidth={borderBottomWidth}
      labelWidth={labelWidth}
      placeholderAlignment={placeholderAlignment}
      iconAlignment={iconAlignment}
      iconColor={iconColor}
    >
      <AtRadio
        options={onLoad||dictOnLoad||onLazyLoad?options:currentData}
        value={value}
        onClick={onChange}
      />
    </LabelWidget>
  );
};

export default TRadioWidget;
